import { getWeaponsOptions, getWeaponsQueryKey } from "@/client/@tanstack/react-query.gen";
import { readCache } from "@/store/action";
import type { GetWeaponsResponse } from "@/client/types.gen";

export type ApiWeapon = GetWeaponsResponse[number];

export const useWeaponsOptions = () => getWeaponsOptions();

export function getWeapons(): GetWeaponsResponse | undefined {
  return readCache<ReturnType<typeof getWeaponsQueryKey>, GetWeaponsResponse>(
    getWeaponsQueryKey()
  );
}

export function getWeaponById(id: number): ApiWeapon | undefined {
  const weapons = getWeapons();
  return weapons?.find(w => w.id === id);
}
